module.exports = __webpack_public_path__ + "img/CertificateScrumFoundations.68eff920.png";